/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getCachedUserToken } from '../../../utilities/caching';
import { gotoUrlEnvironment } from '../../../utilities/helpers';
import { ACCOUNT_REGIONS } from '../../../utilities/constants';
import { walletCurrenciesTypes } from '../constants';
import {
  MANAGE_ASSETS_ACCOUNTS_QUERY_PARAM,
  MANAGE_ASSETS_DEEPLINK_QUERY_PARAMS,
  MANAGE_ASSETS_DEEPLINK_SESSION_KEYS,
  MANAGE_ASSETS_OPEN,
} from './constants';

const ManageAssetsDeeplink = () => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const appId = searchParams.get(MANAGE_ASSETS_DEEPLINK_QUERY_PARAMS.APP_ID);
    const pathname = location.pathname.replace(/\/+$/, '');

    const isRowApp = appId === process.env.REACT_APP_ROW_APP_NAME;
    const isUsApp = appId === process.env.REACT_APP_US_APP_NAME;
    const isValidAppId = isRowApp || isUsApp;
    const isOnRowHost = window.location.hostname === process.env.REACT_APP_FE_BASE_HOSTNAME;
    const isOnUsHost = window.location.hostname === process.env.REACT_APP_US_FE_BASE_HOSTNAME;

    if (isValidAppId && !(isRowApp && isOnRowHost) && !isOnUsHost) {
      gotoUrlEnvironment(ACCOUNT_REGIONS.US, `${pathname.slice(1)}${location.search}`);
      return;
    }

    const token = getCachedUserToken();
    if (!token) {
      sessionStorage.setItem(
        MANAGE_ASSETS_DEEPLINK_SESSION_KEYS.RETURN_URL,
        `${pathname}${location.search}`
      );
      history.push('/onboarding/login');
      return;
    }

    history.push(
      `/dashboard/accounts/${walletCurrenciesTypes.CRYPTO}?${MANAGE_ASSETS_ACCOUNTS_QUERY_PARAM}=${MANAGE_ASSETS_OPEN}`
    );
  }, []);

  return null;
};

export default ManageAssetsDeeplink;
